module.exports = {
  path: 'inicio',
  getChildRoutes(partialNextState, cb) {
    require.ensure([], (require) => {
      cb(null, [        
        require('../app/routes/pages'),
      ]);
    });
  },
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/Inicio'));
    });
  }
};



// WEBPACK FOOTER //
// ./routes/inicio/index.js